import React, { useContext } from 'react'
import { ButtonType, Completed, CustomButton, FormSavePrompt, InputWrapper, PageWrapper } from '../../components'
import { WemoloAccordion, WemoloDropdown } from '../../components/Wemolo'
import { useFormSaveStore } from '../../utils'

import { SHARED_COLORS, hexToRGBA } from '../../utils'
import { MLPCategory, MLPContext } from './MLPContext'
import { useMLPStore } from './MLPStore'
import { MlpCaseItem } from './components'

import {
    findIfAllCasesInBatchAreFilled,
    findTotalAmountOfCasesWithCategory,
    findTotalAmountOfCasesWithCategoryInAllBatches,
    getAmountofCurrentBatchFinishedItems,
    getItemState,
    getTotalCasesFromBatch,
    getTotalCasesFromBatches,
    getTotalResults
} from './utils'
import LocalErrorBoundary from '../../components/LocalErrorBoundary'
import { SENTRYTAGS } from '../../logging'
import styles from './MLPView.module.css'

export const MLPView = () => {
    const { mlpBatches, pushCheckedMlpsHandler, loadingPushCheckedMlps } = useContext(MLPContext)
    const currentBatch = useMLPStore((state) => state.currentBatch)
    const currentActiveBatch = useMLPStore((state) => state.currentActiveBatch)
    const changeCurrentActiveBatch = useMLPStore((state) => state.changeCurrentActiveBatch)
    const results = useMLPStore((state) => state.results)
    const changeCurrentBatch = useMLPStore((state) => state.changeCurrentBatch)
    const setMlpFinished = useMLPStore((state) => state.setMlpFinished)
    const mlpFinished = useMLPStore((state) => state.mlpFinished)
    const setFormChanges = useFormSaveStore((state: { setFormChanges: any }) => state.setFormChanges)

    const optionsForSelect = mlpBatches.map((_batch, index) => ({
        label: `Batch ${index + 1} ${currentActiveBatch === index ? '🟢' : ''}`,
        value: String(index)
    }))

    const currentBatchCases = mlpBatches[currentBatch]

    return (
        <PageWrapper>
            <LocalErrorBoundary tag={SENTRYTAGS.MLP}>
                <FormSavePrompt />
                <WemoloAccordion title="MLP" defaultExpanded={true}>
                    <InputWrapper label="Current batch">
                        <div className={styles.headerRow}>
                            <div className={styles.dropdownCol}>
                                <WemoloDropdown
                                    size="medium"
                                    placeholder="No cases available"
                                    disabled={getTotalCasesFromBatches(mlpBatches) === 0}
                                    options={optionsForSelect}
                                    value={
                                        getTotalCasesFromBatches(mlpBatches) === 0 ? undefined : String(currentBatch)
                                    }
                                    onChange={(id) => {
                                        if (id) changeCurrentBatch(Number(id))
                                    }}
                                />
                            </div>
                            <div className={styles.spacerCol}></div>
                            <div className={styles.statsCol}>
                                <div className={styles.statsRow}>
                                    <div className={styles.batchLabel}>
                                        Current Batch: {getAmountofCurrentBatchFinishedItems(results, currentBatch)} /{' '}
                                        {currentBatchCases ? getTotalCasesFromBatch(mlpBatches, currentBatch) : 0}
                                    </div>
                                    <div
                                        className={styles.numberPill}
                                        style={{ backgroundColor: hexToRGBA(SHARED_COLORS.DELETE, 0.8) }}
                                    >
                                        {findTotalAmountOfCasesWithCategory(results, currentBatch, MLPCategory.MLP)}
                                    </div>
                                    <div
                                        className={styles.numberPill}
                                        style={{ backgroundColor: hexToRGBA(SHARED_COLORS.SAVE, 0.8) }}
                                    >
                                        {findTotalAmountOfCasesWithCategory(
                                            results,
                                            currentBatch,
                                            MLPCategory.Violator
                                        )}
                                    </div>
                                </div>
                                <div className={styles.statsRow}>
                                    <div className={styles.batchLabel}>
                                        Total : {getTotalResults(results)} / {getTotalCasesFromBatches(mlpBatches)}
                                    </div>
                                    <div
                                        className={styles.numberPill}
                                        style={{ backgroundColor: hexToRGBA(SHARED_COLORS.DELETE, 0.8) }}
                                    >
                                        {findTotalAmountOfCasesWithCategoryInAllBatches(results, MLPCategory.MLP)}
                                    </div>
                                    <div
                                        className={styles.numberPill}
                                        style={{ backgroundColor: hexToRGBA(SHARED_COLORS.SAVE, 0.8) }}
                                    >
                                        {findTotalAmountOfCasesWithCategoryInAllBatches(results, MLPCategory.Violator)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </InputWrapper>
                </WemoloAccordion>

                {currentBatchCases && (
                    <>
                        <div>
                            {currentBatchCases.map((mlpCase, index) => {
                                return (
                                    <MlpCaseItem
                                        key={mlpCase.offender.parking_results_uuid}
                                        indexInBatch={index}
                                        //@ts-ignore
                                        caseState={getItemState(results, index, currentBatch)}
                                        isDone={Boolean(getItemState(results, index, currentBatch))}
                                        mlpCase={mlpCase}
                                    />
                                )
                            })}
                        </div>

                        {findIfAllCasesInBatchAreFilled(mlpBatches, results, currentBatch) &&
                            currentActiveBatch === currentBatch &&
                            !mlpFinished && (
                                <div className={styles.submitWrapper}>
                                    <CustomButton
                                        onClick={() => {
                                            pushCheckedMlpsHandler(results[currentActiveBatch], () => {
                                                if (currentBatch === mlpBatches.length - 1) {
                                                    setMlpFinished(true)
                                                } else {
                                                    setFormChanges(false)
                                                    changeCurrentActiveBatch(currentActiveBatch + 1)
                                                    changeCurrentBatch(currentBatch + 1)
                                                }
                                                window.scrollTo({
                                                    top: 0,
                                                    behavior: 'smooth'
                                                })
                                            })
                                        }}
                                        type={ButtonType.SAVE}
                                        isLoading={loadingPushCheckedMlps}
                                        extraProps={{ minWidth: '270px !important;' }}
                                    >
                                        Submit Batch
                                    </CustomButton>
                                </div>
                            )}
                    </>
                )}
                {mlpFinished && (
                    <Completed
                        title="All batches completed!"
                        subtitle="You have successfully processed all MLP cases."
                    />
                )}
            </LocalErrorBoundary>
        </PageWrapper>
    )
}
